import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {withStyles} from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Select from 'material-ui/Select';
import MenuItem from 'material-ui/Menu/MenuItem';
import Modal from 'material-ui/Modal';
import Typography from 'material-ui/Typography';
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table';
import Button from 'material-ui/Button';
import AddIcon from 'material-ui-icons/Add';
import AdminCollectionItem from '../item/index';
import AdminListToolbar from '../../common/list-toolbar/index';
import DeleteDialog from '../../common/delete-dialog/index';

const styles = theme => ({
	root: {
		margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 24}px`
	},
	createButton: {
		position: 'fixed',
		bottom: theme.spacing.unit * 6,
		right: theme.spacing.unit * 6
	},
	deletionWarning: {
		display: 'flex',
		flexFlow: 'column',
		width: '400px',
		margin: 'auto',
		padding: '32px 32px 24px'
	},
	closeDeletionWarning: {
		padding: '1em 2em',
		margin: '24px auto 0',
		alignSelf: 'center'
	}
});

const AdminCollectionList = props => {
	const {
		classes,
		items,
		filesCount,
		handleShowFiles,
		handleEditItem,
		handleDeleteItem,
		handleSelectLanguage,
		handleConfirmDelete,
		handleCancelDelete,
		deleteTarget,
		deleteConfirmation,
		deletionWarning,
		closeDeletionWarning,
		currentLanguage,
		languages
	} = props;

	return (
		<div className={classes.root}>
			<AdminListToolbar
				title="Collections"
				renderActions={() => (
					<Select label="Language" value={currentLanguage} onChange={handleSelectLanguage}>
						{languages.map(lang => (
							<MenuItem
								key={lang.key}
								value={lang.key}
							>
								{lang.value}
							</MenuItem>
						))}
					</Select>
				)}
			/>
			<div className={classes.createButton}>
				<Button
					fab
					color="primary"
					aria-label="Create"
					className={classes.button}
					component={Link}
					to="/admin/collections/create"
				>
					<AddIcon/>
				</Button>
			</div>
			<Paper>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell padding="checkbox">
								&nbsp;
							</TableCell>
							<TableCell padding="none">
								Title
							</TableCell>
							<TableCell padding="dense">
								Description
							</TableCell>
							<TableCell padding="dense" numeric>
								#&nbsp;Files
							</TableCell>
							<TableCell padding="dense">
								Last updated
							</TableCell>
							<TableCell padding="none">
								&nbsp;
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{items
							.filter(i => i.language === currentLanguage)
							.sort((a, b) => a.sortOrder - b.sortOrder)
							.map((item, index) => (
								<AdminCollectionItem
									key={index}
									item={item}
									filesCount={filesCount[item.id] || 0}
									onShowFiles={handleShowFiles}
									onEdit={handleEditItem}
									onDelete={handleDeleteItem}
								/>
							))
						}
					</TableBody>
				</Table>
			</Paper>
			<DeleteDialog
				open={deleteConfirmation}
				deleteTarget={deleteTarget}
				handleCancel={handleCancelDelete}
				handleConfirm={handleConfirmDelete}
			/>
			<Modal
				open={deletionWarning}
				onClose={closeDeletionWarning}
			>

				<Paper className={classes.deletionWarning}>
					<Typography type="title" id="modal-title">
							Sorry, you cannot delete this collections
					</Typography>
					<Typography type="subheading" id="simple-modal-description">
							First of all please remove all content from collection so as to remove collection itself.
					</Typography>
					<Button
						className={classes.closeDeletionWarning}
						onClick={closeDeletionWarning}
						raised
						dense
					>
							Okay
					</Button>
				</Paper>
			</Modal>
		</div>
	);
};

AdminCollectionList.propTypes = {
	classes: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
	filesCount: PropTypes.object.isRequired,
	handleShowFiles: PropTypes.func.isRequired,
	handleEditItem: PropTypes.func.isRequired,
	handleDeleteItem: PropTypes.func.isRequired,
	handleSelectLanguage: PropTypes.func.isRequired,
	handleConfirmDelete: PropTypes.func.isRequired,
	handleCancelDelete: PropTypes.func.isRequired,
	closeDeletionWarning: PropTypes.func.isRequired,
	currentLanguage: PropTypes.string.isRequired,
	languages: PropTypes.array.isRequired,
	deletionWarning: PropTypes.bool.isRequired,
	deleteConfirmation: PropTypes.bool.isRequired,
	deleteTarget: PropTypes.object
};

export default withStyles(styles)(AdminCollectionList);



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/list/list.jsx